import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  Wrapper, OverlayContainer, Container, Header, Content, Footer,
} from './styled';
import { selectWebsiteTheme } from '../../store/slices/website';
import CLFontIcon from '../CLFontIcon';

const CLModal = ({
  isVisible,
  onClose,
  title,
  renderContent,
  renderFooter,
}) => {
  const { colors } = useSelector(selectWebsiteTheme);

  if (!isVisible) {
    return null;
  }


  return (
    <Wrapper>
      <OverlayContainer onClick={onClose} />
      <Container>
        <Header color={colors[4].color}>
          <h1>{title}</h1>
          <button className="hoverable" aria-label="close dialog" type="button" onClick={onClose}>
            <CLFontIcon icon="close" />
          </button>
        </Header>

        <Content>
          {renderContent()}
        </Content>

        <Footer $bColor={colors[3].color}>
          {renderFooter()}
        </Footer>
      </Container>
    </Wrapper>
  );
};

CLModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  renderContent: PropTypes.func.isRequired,
  renderFooter: PropTypes.func.isRequired,
};

export default CLModal;
